import { getStyles } from '../get-styles';

export function getCss(
	element: Element,
	name: string,
	computed?: CSSStyleDeclaration
): string {
	computed = computed || getStyles(element);

	if (computed) {
		return computed.getPropertyValue(name) || computed[name];
	}

	return undefined;
}
